import React from 'react';

function UserIcon({color , width , height}) {
    return (
        <svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.25">
                <path d="M12.9998 2.16666C10.1615 2.16666 7.854 4.47416 7.854 7.31249C7.854 10.0967 10.0315 12.35 12.8698 12.4475C12.9565 12.4367 13.0432 12.4367 13.1082 12.4475C13.1298 12.4475 13.1407 12.4475 13.1623 12.4475C13.1732 12.4475 13.1732 12.4475 13.184 12.4475C15.9573 12.35 18.1348 10.0967 18.1457 7.31249C18.1457 4.47416 15.8382 2.16666 12.9998 2.16666Z" fill={color}/>
                <path d="M18.5035 15.3292C15.481 13.3142 10.5519 13.3142 7.5077 15.3292C6.13187 16.25 5.37354 17.4958 5.37354 18.8283C5.37354 20.1608 6.13187 21.3958 7.49687 22.3058C9.01354 23.3242 11.0069 23.8333 13.0002 23.8333C14.9935 23.8333 16.9869 23.3242 18.5035 22.3058C19.8685 21.385 20.6269 20.15 20.6269 18.8067C20.616 17.4742 19.8685 16.2392 18.5035 15.3292Z" fill={color}/>
            </g>
        </svg>

    );
}

export default UserIcon;
